export default "__VITE_PUBLIC_ASSET__fa561c4e__"